import { render, staticRenderFns } from "./crud-select.vue?vue&type=template&id=e9ff40a0&"
import script from "./crud-select.vue?vue&type=script&lang=js&"
export * from "./crud-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports